import React from 'react';
import './SectionHead.css';

interface SectionHeadProps {
  eyebrow?: string;
  title: string;
  description?: string;
}

const SectionHead: React.FC<SectionHeadProps> = ({ eyebrow, title, description }) => {
  return (
    <div className="sec-head">
      {eyebrow && (
        <div className="sec-eyebrow tagline-line">
          <span>{eyebrow}</span>
        </div>
      )}
      <h2 dangerouslySetInnerHTML={{ __html: title }} />
      {description && <p>{description}</p>}
    </div>
  );
};

export default SectionHead;